import ImageButton from "./ImageButton.ts";
import ICreate from "../interfaces/ICreate.ts";
import IDestroy from "../interfaces/IDestroy.ts";
import Mark from "../marks/Mark.ts";
import VowelMark from "../marks/VowelMark.ts";
import LongMark from "../marks/LongMark.ts";
import BlendMark from "../marks/BlendMark.ts";
import GuardianMark from "../marks/GuardianMark.ts";
import ShortMark from "../marks/ShortMark.ts";
import MarkCodes from "../marks/MarkCodes.ts";
import ARMark from "../marks/ARMark.ts";
import ConsonantYMark from "../marks/ConsonantYMark.ts";
import SoundOfShortEMark from "../marks/SoundOfShortEMark.ts";
import ERSoundOfEarMark from "../marks/ERSoundOfEarMark.ts";
import ERMark from "../marks/ERMark.ts";
import SoundOfLongOMark from "../marks/SoundOfLongOMark.ts";
import SoundOfFMark from "../marks/SoundOfFMark.ts";
import RainbowJSMark from "../marks/RainbowJSMark.ts";
import SoundOfZMark from "../marks/SoundOfZMark.ts";
import SchwaMark from "../marks/SchwaMark.ts";
import SilentVowelMark from "../marks/SilentVowelMark.ts";
import SlideArrowMark from "../marks/SlideArrowMark.ts";
import SoundOfKMark from "../marks/SoundOfKMark.ts";
import SoundALongMark from "../marks/SoundALongMark.ts";
import SoundSHMark from "../marks/SoundSHMark.ts";
import SoundYLongEMark from "../marks/SoundYLongEMark.ts";
import SoundYLongMark from "../marks/SoundYLongMark.ts";
import SoundYShortMark from "../marks/SoundYShortMark.ts";
import SyllableSplitMark from "../marks/SyllableSplitMark.ts";
import UnderlineMark from "../marks/UnderlineMark.ts";
import VoicedVoicelessMark from "../marks/VoicedVoicelessMark.ts";
import VowelExceptionMark from "../marks/VowelExceptionMark.ts";
import VowelExceptionShortSoundMark from "../marks/VowelExceptionShortSoundMark.ts";
import ARSoundOfAirMark from "../marks/ARSoundOfAirMark.ts";
import SoundOfLongAMark from "../marks/SoundOfLongAMark.ts";


export default class MarkSelectionButton extends ImageButton implements ICreate, IDestroy
{

    public markCode:string;

    private mark:Mark;

    constructor(markCode:string, imageURL:string)
    {
        super(imageURL);
        this.markCode = markCode;
    }

    private createMark():void
    {
        let markW;
        let markH;
        let strokeThickness = 8;
        switch(this.markCode)
        {
            case MarkCodes.AI_SOUND_OF_LONG_A:
                strokeThickness = 5;
                this.mark = new SoundOfLongAMark();
                break;
            case MarkCodes.AR_SOUND_OF_AIR:
                this.mark = new ARSoundOfAirMark();
                break;
            case MarkCodes.AR_SOUND_OF_OR:
                this.mark = new ARMark();
                break;
            case MarkCodes.BLEND_2_LETTER:
                markW = 96;
                this.mark = new BlendMark();
                break;
            case MarkCodes.BLEND_3_LETTER:
            case MarkCodes.BLEND_4_LETTER:
                markW = 126;
                this.mark = new BlendMark();
                break;
            case MarkCodes.CONSONANT_Y:
                this.mark = new ConsonantYMark();
                break;
            case MarkCodes.EA_OR_EI_SOUND_OF_LONG_A:
                this.mark = new SoundOfLongAMark();
                break;
            /*case MarkCodes.EA_SOUND_OF_SHORT_E_EA:
                this.mark = new SoundOfShortEMark();
                break;*/
            case MarkCodes.ER_SOUND_OF_EAR:
                this.mark = new ERSoundOfEarMark();
                break;
            case MarkCodes.GUARDIAN:
            case MarkCodes.GUARDIAN_2_LETTER:
            case MarkCodes.GUARDIAN_3_LETTER:
                markW = 48;
                markH = 48;
                this.mark = new GuardianMark();
                break;
            case MarkCodes.LONG:
                markW = 56;
                this.mark = new LongMark();
                break;
            case MarkCodes.OR_SOUND_OF_ER:
                this.mark = new ERMark();
                break;
            case MarkCodes.OW_SOUND_OF_LONG_O:
                this.mark = new SoundOfLongOMark();
                break;
            case MarkCodes.PH_MAKES_SOUND_OF_F:
                this.mark = new SoundOfFMark();
                break;
            case MarkCodes.RAINBOW_J:
                this.mark = new RainbowJSMark();
                break;
            case MarkCodes.RAINBOW_J_GUARDIAN:
            case MarkCodes.RAINBOW_S_GUARDIAN:
                this.mark = new GuardianMark();
                break;
            case MarkCodes.RAINBOW_S:
                this.mark = new RainbowJSMark(null, "s");
                break;
            case MarkCodes.S_SOUND_OF_Z:
                this.mark = new SoundOfZMark();
                break;
            case MarkCodes.SCHWA:
                this.mark = new SchwaMark();
                break;
            case MarkCodes.SCHWA_LE_ENDINGS:
                this.mark = new SchwaMark(null, true);
                break;
            case MarkCodes.SHORT:
                markW = 64;
                this.mark = new ShortMark();
                break;
            case MarkCodes.SILENT_VOWEL:
                this.mark = new SilentVowelMark();
                break;
            case MarkCodes.SLIDE_ARROW:
                this.mark = new SlideArrowMark();
                break;
            /*case MarkCodes.SOUND_OF_K:
                this.mark = new SoundOfKMark();
                break;*/
            case MarkCodes.SOUND_OF_LONG_A:
                this.mark = new SoundALongMark();
                break;
            /*case MarkCodes.SOUND_OF_SH:
                this.mark = new SoundSHMark();
                break;*/
            case MarkCodes.SOUND_OF_Y_LONG_E:
                this.mark = new SoundYLongEMark();
                break;
            case MarkCodes.SOUND_OF_Y_LONG_I:
                this.mark = new SoundYLongMark();
                break;
            case MarkCodes.SOUND_OF_Y_SHORT_I:
                this.mark = new SoundYShortMark();
                break;
            case MarkCodes.SYLLABLE_END:
                this.mark = new SyllableSplitMark();
                break;
            case MarkCodes.UNDERLINE:
                this.mark = new UnderlineMark();
                break;
            case MarkCodes.VOICED_TH:
                this.mark = new VoicedVoicelessMark();
                break;
            case MarkCodes.VOICELESS_TH:
                this.mark = new VoicedVoicelessMark(null, "");
                break;
            case MarkCodes.VOWEL:
                markW = 40;
                markH = 40;
                this.mark = new VowelMark();
                break;
            case MarkCodes.VOWEL_2_LETTER:
                markW = 40;
                markH = 40;
                this.mark = new VowelMark();
                break;
            case MarkCodes.VOWEL_EXCEPTION:
                this.mark = new VowelExceptionMark();
                break;
            case MarkCodes.VOWEL_EXCEPTION_SHORT_SOUND:
                this.mark = new VowelExceptionShortSoundMark();
                break;
            case MarkCodes.VOWEL_SHORT_O_SOUND:
                this.mark = new VowelExceptionShortSoundMark();
                break;
        }
        if(markW)
        {
            this.mark.markWidth = markW;
        }
        if(markH)
        {
            this.mark.markHeight = markH;
        }
        this.mark.strokeThickness = strokeThickness;
        this.mark.pivot.set(this.mark.markWidth/2, this.mark.markHeight/2);
        this.addChild(this.mark);
        this.mark.create();
        this.mark.x = this.image.width/2;
        if(this.markCode == MarkCodes.PH_MAKES_SOUND_OF_F)
        {
            this.mark.y = this.image.height/4;
        }
        else
        {
            this.mark.y = this.image.height/2;
        }
    }


    public override create():void
    {
        super.create();
        this.createMark();
    }

    public override destroy():void
    {
        super.destroy();
    }

    public hide():void
    {
        this.visible = false;
    }

    public show():void
    {
        this.visible = true;
    }
}